import React from "react";

import Loader from 'react-loader-spinner'



const LoaderClass = ({ ...props }) => {
    let loaderObj = props.isLoading;
    return (
        <div className="LLoader-Div">
            <div className="LLoader-Father">
                <div >
                    <Loader
                        type="ThreeDots"
                        color="#01b9c1"
                        height={150}
                        width={150}
                        visible={true}
                    />
                </div>
                <div className="LLoader-Title">
                    {loaderObj.loadingTitle}
                </div>
                <div className="LLoader-Subtitle">
                    {loaderObj.loadingMessage}
                </div>
            </div>
        </div>
    );
};

export default LoaderClass;
